import Vue from 'vue'
import commonMutations from '@/store/ui/common/mutations'

const mutations = {
    ...commonMutations,
    setSelectedDsp(state, { selectedDsp }) {
        Vue.set(state, 'selectedDsp', selectedDsp)
    },
    setZeroState(state, { zeroState }) {
        Vue.set(state, 'zeroState', zeroState)
    },
    setDeletedConfig(state, { id }) {
        Vue.set(state, 'deletedConfigId', id)
    }
}

export default mutations
